/* Move only Shopify Inbox's exported activator above the final footer content. */
(() => {
 'use strict';
 const clearance=(viewportHeight,top,bottom)=>bottom<=0||top>=viewportHeight?0:Math.max(0,Math.min(viewportHeight-110,viewportHeight-20-top+16));
 if(typeof module==='object'&&module.exports){module.exports={clearance};return;}
 let release=()=>{};
 function mount(){
  release();const footer=document.querySelector('[data-liotro-footer-bottom]');if(!footer)return;
  const protectedLine=document.querySelector('.liotro-footer-signoff')||footer.querySelector('.liotro-footer-ending>span:last-child')||footer;
  let frame=0,visible=false;
  const update=()=>{frame=0;const r=protectedLine.getBoundingClientRect();document.documentElement.style.setProperty('--liotro-chat-lift',clearance(window.innerHeight,r.top,r.bottom)+'px');};
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
  const scroll=()=>{if(visible)schedule();};
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();});observer.observe(protectedLine);
  const resize=new ResizeObserver(schedule);resize.observe(protectedLine);
  window.addEventListener('scroll',scroll,{passive:true});window.addEventListener('resize',schedule);schedule();
  release=()=>{observer.disconnect();resize.disconnect();window.removeEventListener('scroll',scroll);window.removeEventListener('resize',schedule);if(frame)cancelAnimationFrame(frame);};
 }
 document.addEventListener('shopify:section:load',mount);mount();
})();
